export class SceneAssetRelation {
    sceneAssetRelationId: number;
    baseAssetId: number;
    xPos: string;
    yPos: string;
    zPos: string;
    position: string;
    xScale: string;
    yScale: string;
    zScale: string;
    scale: string;
    sceneId: number;
    textToSpeechUrl: string;
    isVisible: boolean = true;
}